export enum TabId {
  caseSelection = 'case',
  missedInformation = 'missed',
  patient = 'patient',
  insurance = 'insurance',
  physician = 'physician',
  clinical = 'clinical',
  prescription = 'prescription',
  consent = 'consent',
}